import {graphql} from 'react-relay'

export const parametersQuery = graphql`
  query BuildParametersTabParametersQuery($buildLocator: String!) {
    build(buildLocator: $buildLocator) {
      ...useQueryBuildParametersBuild
    }
  }
`
